export default __webpack_public_path__ + "static/media/editpencil.46965415.png";